<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="班组名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="groupName">
              <a-input v-model="model.groupName" placeholder="请输入班组名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24"  v-if=" !userInfo.thirdAccount ">
            <a-form-model-item label="企业" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="corpId">
              <j-dict-select-tag type="list" v-model="model.corpId" dictCode="`iwt-wf`.wf_consumer_corp,corp_name,id" placeholder="请选择企业" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-textarea v-model="model.remark" rows="4" placeholder="请输入备注" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'WfConsumerCorpGroupForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           groupName: [
              { required: true, message: '请输入班组名称!'},
           ],
           corpId: [
              { required: true, message: '请输入企业!'},
           ],
        },
        url: {
          add: "/wf/corpGroup/add",
          edit: "/wf/corpGroup/edit",
          queryById: "/wf/corpGroup/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      userInfo() {
        return this.$store.getters.userInfo
      }
    },
    created () {
      //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
      if(!!this.userInfo.thirdAccount){
        this.model.corpId = this.userInfo.corpIds;
      }
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
    }
  }
</script>